module.exports = __webpack_public_path__ + "static/media/Wellgo uses telemedicine software for weight loss treatments.186c18e3.webp";